import React, { Component } from 'react';
import Avatar from '@mui/material/Avatar';
import AppContext from 'components/appContext';

class UserPicture extends Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <React.Fragment>
                <Avatar
                    src={this.context.userDetails.PICTURE}
                    style={{
                        width: 'auto',
                        height: '100%',
                        display: 'inline-block',
                        borderRadius: '0.5em',
                        maxWidth: '70px',
                        alignSelf: 'flex-end',
                    }}
                />
            </React.Fragment>
        )
    }
}

export default UserPicture;